import { MessageCircle } from 'lucide-react'

const WhatsAppFloat = () => {
  return (
    <div className="fixed bottom-6 right-6 z-50" data-testid="whatsapp-float-container">
      {/* Ping ring */}
      <span
        className="absolute inset-0 bg-[#25D366] opacity-20 animate-ping"
        style={{ borderRadius: 0 }}
      />
      <a
        href="https://wa.me/5547988114676"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-float-btn"
        aria-label="Falar com Marido de Aluguel pelo WhatsApp"
        className="relative flex items-center justify-center w-14 h-14 bg-[#25D366] shadow-[0_4px_24px_rgba(37,211,102,0.45)] hover:bg-[#20ba5a] hover:shadow-[0_6px_28px_rgba(37,211,102,0.55)] transition-all duration-200 active:scale-95"
      >
        <MessageCircle size={27} className="text-white" fill="white" />
      </a>
    </div>
  )
}

export default WhatsAppFloat
